import SEOHead from "@/components/base/SEOHead";
import SchemaOrg from "@/components/base/SchemaOrg";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import HotTopics from "./components/HotTopics";
import CategoryNav from "./components/CategoryNav";
import UserComments from "./components/UserComments";

export default function Home() {
  return (
    <>
      <SEOHead
        title="51爆料 | 51爆料吃瓜与51爆料黑料 | 网红每日大赛实时追踪"
        description="51爆料是你搜黑料、看大赛的集合站。聚合51爆料网、51爆料吃瓜及全网反差不设防的吃瓜视频，所有八卦和明星消息都在这里。"
        keywords="51爆料,51爆料网,51爆料吃瓜,51爆料黑料,51爆料每日大赛,实时吃瓜,网红反差,明星八卦,黑料追踪"
        canonicalUrl="/"
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: "51爆料",
          url: "https://www.51baoliao.com",
          logo: "https://www.51baoliao.com/logo.png",
          description: "51爆料是你搜黑料、看大赛的集合站。聚合51爆料网、51爆料吃瓜及全网反差不设防的吃瓜视频，所有八卦和明星消息都在这里。",
          address: {
            "@type": "PostalAddress",
            addressLocality: "北京",
            addressRegion: "北京",
            addressCountry: "CN",
          },
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "400-888-5151",
            contactType: "customer service",
          },
          sameAs: [
            "https://weibo.com",
            "https://www.douyin.com",
          ],
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: "51爆料",
          url: "https://www.51baoliao.com",
          description: "51爆料是你搜黑料、看大赛的集合站。聚合51爆料网、51爆料吃瓜及全网反差不设防的吃瓜视频，所有八卦和明星消息都在这里。",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://www.51baoliao.com/search?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "51爆料 - 首页",
          url: "https://www.51baoliao.com",
          description: "51爆料是你搜黑料、看大赛的集合站。聚合51爆料网、51爆料吃瓜及全网反差不设防的吃瓜视频，所有八卦和明星消息都在这里。",
          isPartOf: {
            "@type": "WebSite",
            name: "51爆料",
            url: "https://www.51baoliao.com",
          },
        }}
      />

      <main>
        <Navbar />
        <HeroSection />
        <HotTopics />
        <CategoryNav />
        <UserComments />
      </main>
      <Footer />
    </>
  );
}